import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getTipoLogradouro, cadastrarTipoLogradouro, alterarTipoLogradouro, excluirTipoLogradouro } from '../../../api';
import { CadastroBasicoNomeSituacaoForm } from '../../../components/CadastroBasicoNomeSituacaoForm';
var TiposLogradourosEditar = function () {
    var services = {
        getItem: getTipoLogradouro,
        cadastrarItem: cadastrarTipoLogradouro,
        alterarItem: alterarTipoLogradouro,
        excluirItem: excluirTipoLogradouro,
    };
    return _jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.TIPOS_LOGRADOUROS, paginaPermissao: FUNCIONALIDADES.TIPOS_LOGRADOUROS, rota: ROUTES.TIPOS_LOGRADOUROS, services: services });
};
export default TiposLogradourosEditar;
